/**
 * Translates notification messages from English to the user's selected language
 * Uses regex patterns to find and replace common notification phrases
 */
export const translateNotification = (message, lg) => {
  if (!message || !lg) return message;

  let translatedMessage = message;

  // Pattern 1: "sent you a message!"
  // Matches: "John sent you a message!" or "John Doe sent you a message!"
  // Handles names with spaces, special characters, and various name formats
  const sentMessagePattern = /([A-Za-zÀ-ÿ\s'-]+?)\s+sent you a message!/i;
  if (sentMessagePattern.test(translatedMessage)) {
    translatedMessage = translatedMessage.replace(
      sentMessagePattern,
      (match, name) => {
        const trimmedName = name.trim();
        return `${trimmedName} ${lg.sentYouAMessage || "sent you a message!"}`;
      }
    );
  }

  // Pattern 2: "just joined your [event type]"
  // Matches: "John just joined your Book Club" or "John just joined your Book Club \"Event Title\"."
  // Also handles names with spaces: "John Doe just joined your Book Club"
  // Handles various event types: Book Club, Book Duo, Silent Reading, etc.
  // The pattern matches event type as one or more words (letters, spaces, hyphens) up to optional quote or period
  // Using greedy matching (+) to ensure we capture the full event type name
  const joinedPattern = /([A-Za-zÀ-ÿ\s'-]+?)\s+just joined your\s+([A-Za-zÀ-ÿ\s&-]+)(?:\s+"([^"]+)")?\s*\.?$/i;
  if (joinedPattern.test(translatedMessage)) {
    translatedMessage = translatedMessage.replace(
      joinedPattern,
      (match, name, eventType, eventTitle) => {
        const trimmedName = name.trim();
        const eventTypeName = eventType.trim();
        const titlePart = eventTitle ? ` "${eventTitle}"` : "";
        return `${trimmedName} ${lg.justJoinedYour || "just joined your"} ${eventTypeName}${titlePart}.`;
      }
    );
  }

  return translatedMessage;
};

